import { render } from "./expertAcceptBookingModal.vue?vue&type=template&id=2ea63fec&ts=true"
import script from "./expertAcceptBookingModal.vue?vue&type=script&lang=ts"
export * from "./expertAcceptBookingModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__